function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM10.4244 6.3324C9.75436 5.39434 8.54829 4.90298 7.34222 5.171C6.13615 5.43901 5.27254 6.39195 5.09387 7.53847L10.4244 6.3324ZM8.66741 10.7993C9.397 10.6355 10.0373 10.2037 10.4542 9.59325L12.9854 10.1888C12.3005 11.6629 10.9604 12.8243 9.23322 13.2115C6.29994 13.8815 3.38155 12.0947 2.69662 9.20612C2.01169 6.31751 3.84313 3.45868 6.77641 2.78864C9.70969 2.1186 12.643 3.92026 13.313 6.79398C13.3875 7.13644 13.4321 7.4938 13.447 7.85115L11.7794 8.22339L10.9158 8.41696L5.57034 9.62303C6.24038 10.576 7.46134 11.0673 8.66741 10.7993Z",
  fill: "#808080"
});

function SvgEventbrite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventbrite);
export default __webpack_public_path__ + "static/media/eventbrite.7cc73eda.svg";
export { ForwardRef as ReactComponent };